export default __webpack_public_path__ + "static/media/home-events-conference-img-09.e1186e3a.jpg";